module.exports = __webpack_public_path__ + "static/SortTheCourt1-1c655b8f0450dcd6a6f26446e57b7053.png";